import Factoring from "../../components/Factoring";

const FactoringPage = () => <Factoring />;

export default FactoringPage;
